import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import type { TrustPage } from '@/mocks/trustPages';

export default function TrustContent({ page }: { page: TrustPage }) {
  const { t } = useTranslation();

  return (
    <div className="mx-auto max-w-3xl px-4 py-12 md:px-6">
      <nav aria-label="Breadcrumb" className="text-sm text-foreground-500">
        <ol className="flex flex-wrap items-center gap-1.5">
          <li>
            <Link to="/" className="transition-colors hover:text-primary-700">
              {t('nav.home')}
            </Link>
          </li>
          <li aria-hidden="true">/</li>
          <li className="text-foreground-700">{page.title}</li>
        </ol>
      </nav>

      <h1 className="mt-4 font-heading text-2xl font-extrabold leading-tight text-foreground-950 md:text-4xl">
        {page.title}
      </h1>

      <div className="mt-6 space-y-4">
        {page.intro.map((p, i) => (
          <p key={i} className="text-base leading-relaxed text-foreground-700">
            {p}
          </p>
        ))}
      </div>

      <div className="mt-8">
        {page.sections.map((section, idx) => (
          <section key={idx} className="mt-8 first:mt-0">
            <h2 className="font-heading text-xl font-bold text-foreground-950 md:text-2xl">
              {section.heading}
            </h2>
            {section.paragraphs.map((p, i) => (
              <p key={i} className="mt-3 text-base leading-relaxed text-foreground-700">
                {p}
              </p>
            ))}
          </section>
        ))}
      </div>
    </div>
  );
}